(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[43615,93812],{

/***/ 43615:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Cards_BlogCard; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./UI/components/LinkWrapper/index.jsx + 2 modules
var LinkWrapper = __webpack_require__(56362);
// EXTERNAL MODULE: ./UI/components/Illustration/index.jsx + 1 modules
var Illustration = __webpack_require__(93812);
// EXTERNAL MODULE: ./utils/helper.js
var helper = __webpack_require__(6572);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
// EXTERNAL MODULE: ./UI/components/Svg/index.jsx
var Svg = __webpack_require__(6778);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 21 modules
var es = __webpack_require__(2664);
// EXTERNAL MODULE: ./redux/selectors/layout.js
var layout = __webpack_require__(19341);
// EXTERNAL MODULE: ./utils/constants.js
var constants = __webpack_require__(96076);
;// CONCATENATED MODULE: ./UI/components/Cards/BlogCard/utils/useCardProps.js





/* harmony default export */ function useCardProps(props) {
    var index = props.index, slug = props.slug, categoryTag = props.categoryTag, previewImageUrl = props.previewImageUrl, publishedAt = props.publishedAt, tagsListCollection = props.tagsListCollection, rest = (0,_object_without_properties/* default */.Z)(props, [
        "index",
        "slug",
        "categoryTag",
        "previewImageUrl",
        "publishedAt",
        "tagsListCollection"
    ]);
    var ref = tagsListCollection.items[0], tagSlug = ref.slug;
    var isTabletResolution = (0,es.useSelector)(layout/* selectIsTablet */.aT);
    var ref1 = constants/* ROUTES.article.getRoute */.y2.article.getRoute(slug), articlePath = ref1.path;
    var ref2 = constants/* ROUTES.blog.getRoute */.y2.blog.getRoute(categoryTag), categoryPath = ref2.path;
    var imageUrl = previewImageUrl.url;
    var hashLinks = "#".concat((tagSlug || "").replace("-", ""));
    return (0,_object_spread/* default */.Z)({
        articlePath: articlePath,
        categoryPath: categoryPath,
        imageUrl: imageUrl,
        hashLinks: hashLinks,
        publishedAt: publishedAt,
        index: index,
        isTabletResolution: isTabletResolution
    }, rest);
};

// EXTERNAL MODULE: ./UI/components/Cards/BlogCard/styles.module.scss
var styles_module = __webpack_require__(32462);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./UI/components/Cards/BlogCard/index.jsx











var BlogCard = function(props) {
    var ref = useCardProps(props), articlePath = ref.articlePath, imageUrl = ref.imageUrl, imageSizes = ref.imageSizes, publishedAt = ref.publishedAt, title = ref.title, hashLinks = ref.hashLinks, introduction = ref.introduction;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkWrapper/* default */.Z, {
        isLocalLink: true,
        path: articlePath,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
            className: (styles_module_default()).article,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Illustration["default"], (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, imageSizes), {
                    src: imageUrl,
                    className: (styles_module_default()).image,
                    objectFit: "cover",
                    layout: "fill",
                    transparent: true
                })),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (styles_module_default()).articleContent,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (styles_module_default()).date,
                            children: (0,helper/* formatDate */.p6)(publishedAt)
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                            className: (styles_module_default()).title,
                            children: [
                                (0,lodash.truncate)(title, {
                                    length: 65
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg["default"], {
                                    type: "arrowNarrowUp",
                                    className: (styles_module_default()).arrowIcon
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: (styles_module_default()).introduction,
                            children: (0,lodash.truncate)(introduction, {
                                length: 70
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (styles_module_default()).category,
                            children: hashLinks
                        })
                    ]
                })
            ]
        })
    });
};
BlogCard.propTypes = {
    index: (prop_types_default()).number,
    categoryTag: (prop_types_default()).node,
    previewImageUrl: prop_types_default().instanceOf(Object),
    publishedAt: (prop_types_default()).string
};
/* harmony default export */ var Cards_BlogCard = (BlogCard);


/***/ }),

/***/ 93812:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ components_Illustration; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var node_modules_classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(node_modules_classnames);
// EXTERNAL MODULE: ./UI/components/Illustration/utils/helpers.js
var helpers = __webpack_require__(45783);
// EXTERNAL MODULE: ./UI/components/Illustration/styles.module.scss
var styles_module = __webpack_require__(31890);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./UI/components/Illustration/utils/useIllustration.js





/* harmony default export */ function useIllustration(_param) {
    var src = _param.src, isStatic = _param.isStatic, classnames = _param.className, _lazyBoundary = _param.lazyBoundary, lazyBoundary = _lazyBoundary === void 0 ? "700px" : _lazyBoundary, apiParams = _param.apiParams, transparent = _param.transparent, placeholderProp = _param.placeholder, priority = _param.priority, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "src",
        "isStatic",
        "className",
        "lazyBoundary",
        "apiParams",
        "transparent",
        "placeholder",
        "priority"
    ]);
    var loader = isStatic ? function(param) {
        var staticSrc = param.src;
        return staticSrc;
    } : function(args) {
        return (0,helpers/* getContentfulImage */.t)((0,_object_spread/* default */.Z)({
            transparent: transparent
        }, args, apiParams));
    };
    var className = classnames_default()((styles_module_default()).image, classnames);
    var lazyProps = !priority ? {
        placeholder: placeholderProp || (transparent ? "blur" : "empty"),
        blurDataURL: (0,helpers/* getContentfulImage */.t)({
            src: src,
            quality: 1,
            format: "webp",
            transparent: transparent
        })
    } : {};
    return (0,_object_spread/* default */.Z)({
        src: src,
        loader: loader,
        className: className,
        lazyBoundary: lazyBoundary,
        priority: priority
    }, lazyProps, rest);
};

;// CONCATENATED MODULE: ./UI/components/Illustration/index.jsx








var Illustration = /*#__PURE__*/ (0,react.memo)(function(props) {
    var _ref = useIllustration(props), className = _ref.className, style = _ref.style, containerClasses = _ref.containerClasses, restProps = (0,_object_without_properties/* default */.Z)(_ref, [
        "className",
        "style",
        "containerClasses"
    ]);
    if (!(restProps === null || restProps === void 0 ? void 0 : restProps.src) || restProps.placeholder === "blur" && !restProps.blurDataURL) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("picture", {
        className: classnames_default()(className, containerClasses),
        style: style,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), (0,_object_spread/* default */.Z)({}, restProps))
    });
});
Illustration.defaultProps = {
    layout: "fill",
    alt: "",
    transparent: false,
    apiParams: {}
};
Illustration.propTypes = {
    transparent: (prop_types_default()).bool,
    // For more props check https://nextjs.org/docs/api-reference/next/legacy/image
    src: (prop_types_default()).string.isRequired,
    alt: (prop_types_default()).string,
    layout: prop_types_default().oneOf([
        "fill",
        "intrinsic",
        "fixed",
        "responsive", 
    ]),
    placeholder: prop_types_default().oneOf([
        "blur",
        "empty", 
    ]),
    // Check https://www.contentful.com/developers/docs/references/images-api/ for detailed api
    apiParams: prop_types_default().instanceOf(Object)
};
/* harmony default export */ var components_Illustration = (Illustration);


/***/ }),

/***/ 32462:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"article":"styles_article__IWzdw","image":"styles_image__vqj_b","articleContent":"styles_articleContent__L6ekc","date":"styles_date__5e7dd","title":"styles_title__bjea8","arrowIcon":"styles_arrowIcon__7mh2q","introduction":"styles_introduction__Wu94q","category":"styles_category__sPNU4"};

/***/ }),

/***/ 31890:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"image":"styles_image__T17hn"};

/***/ })

}]);